export default "__VITE_ASSET__Cx9kPREO__"